import React from "react";
import ReactDOM from 'react-dom';
import App from "./App";

const container = document.querySelector('.root');
ReactDOM.render(<App />, container);
